import Modal from 'AppointmentBox/Modal';
import Text from 'components/Text';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
type Props = {};
// Nhãn nút mặc định là NO/YES; truyền options để đổi cho từng chỗ gọi.
type ConfirmOptions = { okText?: string; cancelText?: string };
type Ref = {
  open: (callback: () => void, title?: string, message?: string, options?: ConfirmOptions) => void;
  close: () => void;
};
export const modalConfirmRef = React.createRef<Ref>();
const ModalConfirm = forwardRef<Ref, Props>(({ }, ref) => {
  const [visible, setVisible] = useState(false);
  const callbackRef = useRef<() => void>(() => undefined);
  const handleClose = () => setVisible(false);
  const [title, setTitle] = useState('');
  const [msg, setMsg] = useState('');
  const [okText, setOkText] = useState('YES');
  const [cancelText, setCancelText] = useState('NO');
  const handleOk = () => {
    callbackRef.current();
    setVisible(false);
  };

  useImperativeHandle(ref, () => ({
    open: (callback, _title, _msg, options) => {
      callbackRef.current = callback;
      setTitle(_title || '');
      setMsg(_msg || '');
      setOkText(options?.okText || 'YES');
      setCancelText(options?.cancelText || 'NO');
      setVisible(true);
    },
    close: () => setVisible(false),
  }));

  return (
    <Modal cancelText={cancelText} okText={okText} open={visible} title={title || 'Warning'} onCancel={handleClose} onOk={handleOk} width='600px' height='auto'>
      <Container>
        <Text variant='CONTENT_1' textAlign='center'>{msg || 'Are you sure?'}</Text>
      </Container>
    </Modal>
  );
});
ModalConfirm.displayName = 'ModalConfirm';
export default ModalConfirm;
export const useModalConfirmContext = (): [React.RefObject<Ref>, JSX.Element] => {
  const ref = useRef<Ref>(null);
  const context = <ModalConfirm ref={ref} />;
  return [ref, context];
};

const Container = styled.div`
  padding: 0 16px;
  padding-top: 16px;
`;